import { reduxType } from "../../interfaces/reducerType"
const defaultState: string = "1";
function reducer(state = defaultState, { type, payload }: reduxType) {
    switch (type) {
        case "setRegionBills":
            return payload
        default:
            return state;
    }
}
export default reducer;